<div class="aqx-subscriptions-component container-fluid">
  <h1>
    My Subscriptions
  </h1>
  <i class="fa fa-spin fa-spinner"
     *ngIf="fetching">
  </i>
  <em *ngIf="fetchingComplete && (!allSubscriptions || allSubscriptions.length === 0)">
    No subscriptions.
  </em>
  <div *ngIf="fetchingComplete && allSubscriptions?.length > 0">
    <!--{{subscription | json}}-->
    <table class="table table-bordered table-sm"
    style="width: auto;">
      <thead class="thead-light">
        <tr>
          <th></th>
          <th colspan="3"
              class="text-center"
              style="font-variant: small-caps">
            Subscription
          </th>
          <th colspan="3"
              class="text-center"
              style="font-variant: small-caps">
            Application
          </th>
        </tr>
        <tr>
          <th></th>
          <th>API</th>
          <!--<th>Subscription ID</th>-->
          <th>Status</th>
          <th>Tier</th>
          <!--<th>Application ID</th>-->
          <th>
            Application Name
          </th>
          <th>
            Description
          </th>
          <th>
            Status
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let subscription of allSubscriptions; let index = index">
          <td class="text-right">
            {{index + 1}}
          </td>
          <td>
            <a routerLink="/apis/{{subscription.apiIdentifier}}"
               href=""
               [queryParams]="{title: subscription.apiDisplayName}">
              {{subscription.apiDisplayName}}
            </a>
          </td>
          <!--<td>-->
            <!--{{subscription.subscriptionId}}-->
          <!--</td>-->
          <td>
            {{subscription.status | titlecase}}
          </td>
          <td>
            {{subscription.tier}}
          </td>
          <!--<td>-->
            <!--{{subscription.applicationId}}-->
          <!--</td>-->
          <td>
            {{subscription.application.name}}
          </td>
          <td>
            {{subscription.application.description}}
          </td>
          <td>
            {{subscription.application.status | titlecase}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
